var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticStyle:{"margin-left":"5px"}},[(_vm.order.fully_printed == 1)?_c('div',{staticClass:"tag is-success"},[_vm._v("F/P")]):_vm._e(),(_vm.order.part_printed == 1)?_c('div',{staticClass:"tag is-link"},[_vm._v("P/P")]):_vm._e(),(_vm.order.cut_sew == 1)?_c('div',{staticClass:"tag is-warning"},[_vm._v("C/S")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }